import qs from "qs";

export const STRAPI_BASE_URL =
  process.env.REACT_APP_STRAPI_ENDPOINT || "http://localhost:1337";
export const STRAPI_CDN_URL =
  process.env.REACT_APP_CDN_URL || "http://localhost:1337/uploads";

export async function getNuestroParque() {
  try {
    const query = qs.stringify({
      populate: "*",
      sort: ["id:asc"],
    });

    const res = await fetch(`${STRAPI_BASE_URL}/api/plg-nuestro-parques?${query}`);
    const data = await res.json();

    return data.data || [];
  } catch (err) {
    console.error("Error cargando Nuestro Parque:", err);
    return [];
  }
}